// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3knJt","container":"styles_container__2oOnL","title":"styles_title__TaODO","wrapper":"styles_wrapper__1kuR8","answer":"styles_answer__3F_CK"};